import React from "react";
import { LandingScreenContainer } from "../../../containers";

export const LandingScreen = () => {
  return <LandingScreenContainer />;
};
